// eslint-disable-next-line
export default {
  count: 18,
  next: null,
  previous: null,
  results: [
    {
      user: "jupyter",
      name: "datascience-notebook",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description:
        "Jupyter Notebook Data Science Stack from https://github.com/jupyter/docker-stacks",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 670,
      pull_count: 10207266,
      last_updated: "2020-06-18T04:26:33.972055Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "scipy-notebook",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description:
        "Jupyter Notebook Scientific Python Stack from https://github.com/jupyter/docker-stacks",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 242,
      pull_count: 4602250,
      last_updated: "2020-06-18T03:44:41.929091Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "all-spark-notebook",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description:
        "Jupyter Notebook Python, Scala, R, Spark, Mesos Stack from https://github.com/jupyter/docker-stacks",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 301,
      pull_count: 4019938,
      last_updated: "2020-06-18T04:52:51.620432Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "tensorflow-notebook",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description:
        "Jupyter Notebook Scientific Python Stack w/ Tensorflow from https://github.com/jupyter/docker-stacks",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 220,
      pull_count: 3047042,
      last_updated: "2020-06-18T04:39:42.385206Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "minimal-notebook",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description:
        "Minimal Jupyter Notebook Stack from https://github.com/jupyter/docker-stacks\n",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 107,
      pull_count: 1913726,
      last_updated: "2020-06-18T03:27:30.608249Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "base-notebook",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description:
        "Small base image for Jupyter Notebook stacks from https://github.com/jupyter/docker-stacks",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 108,
      pull_count: 1795971,
      last_updated: "2020-06-18T03:11:18.980803Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "nbviewer",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description: "Jupyter Notebook Viewer",
      is_private: false,
      is_automated: true,
      can_edit: false,
      star_count: 23,
      pull_count: 530905,
      last_updated: "2020-05-28T09:50:22.896383Z",
      is_migrated: true,
    },
    {
      user: "jupyter",
      name: "pyspark-notebook",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description:
        "Jupyter Notebook Python, Spark, Mesos Stack from https://github.com/jupyter/docker-stacks",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 160,
      pull_count: 401279,
      last_updated: "2020-06-18T04:10:44.195263Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "repo2docker",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description: "Turn git repositories into Jupyter enabled Docker Images",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 12,
      pull_count: 231884,
      last_updated: "2020-06-19T08:54:42.697321Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "r-notebook",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description:
        "Jupyter Notebook R Stack from https://github.com/jupyter/docker-stacks",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 31,
      pull_count: 193498,
      last_updated: "2020-06-18T03:57:24.171547Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "demo",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description: "(DEPRECATED) Demo of the IPython/Jupyter Notebook",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 14,
      pull_count: 73069,
      last_updated: "2017-12-18T16:19:49.326037Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "tmpnb",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description: "(DEPRECATED) tmpnb, the temporary notebook service",
      is_private: false,
      is_automated: true,
      can_edit: false,
      star_count: 9,
      pull_count: 8798,
      last_updated: "2018-01-24T14:54:00.724024Z",
      is_migrated: true,
    },
    {
      user: "jupyter",
      name: "statuspage",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description: "",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 0,
      pull_count: 3970,
      last_updated: "2020-03-04T20:29:00.792303Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "nature-demo",
      namespace: "jupyter",
      repository_type: null,
      status: 1,
      description:
        'Demo image for the "Interactive notebooks: Sharing the code" in Nature',
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 1,
      pull_count: 1373,
      last_updated: "2015-11-12T23:20:04.901157Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "nbcache",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description: "memcache layer used by our nbviewer deployments",
      is_private: false,
      is_automated: true,
      can_edit: false,
      star_count: 1,
      pull_count: 617,
      last_updated: "2017-08-27T19:47:16.412199Z",
      is_migrated: true,
    },
    {
      user: "jupyter",
      name: "nature-base",
      namespace: "jupyter",
      repository_type: null,
      status: 1,
      description: "Base image for jupyter/nature-demo",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 1,
      pull_count: 100,
      last_updated: "2015-11-14T01:59:44.352028Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "cdn.jupyter.org",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description: "",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 0,
      pull_count: 48,
      last_updated: "2020-03-04T21:23:33.443314Z",
      is_migrated: false,
    },
    {
      user: "jupyter",
      name: "nbviewer-statuspage",
      namespace: "jupyter",
      repository_type: "image",
      status: 1,
      description: "statuspage data publisher for nbviewer",
      is_private: false,
      is_automated: false,
      can_edit: false,
      star_count: 0,
      pull_count: 34,
      last_updated: "2020-05-28T09:52:50.390424Z",
      is_migrated: false,
    },
  ],
};
